import { TOKEN_KEY } from "@features/auth/constants";

export const getAccessToken = () => {
    if (typeof window === "undefined") {
        return "";
    }
    const token = localStorage.getItem(TOKEN_KEY);
    return token || "";
};